import {
  AllowancePayload,
  AllowanceResponse,
  AllowancesResponse,
  Id,
  Options,
  Resource,
  SuccessResponse
} from 'services/api';

import Company from './Company.service';

export default class Allowance extends Company {
  private static instance: Allowance;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
    // this related to how typescript transpile this line in es5
    // e.g. var _this = _super.call(this) || this;
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Get a list of company allowances
   * @param {Id} [company_id] (optional) company id
   */
  list(params?: Record<string, any>) {
    return this.getEntities<AllowancesResponse>(Resource.Allowances, params);
  }

  /**
   * Get a allowance by id
   * @param {Id} id allowance id
   */
  get(id: Id) {
    return this.getEntity<AllowanceResponse>(Resource.Allowance, id);
  }

  /**
   * Create a allowance
   * @param {AllowancePayload} payload
   * @param {string} payload.name departmnet name
   */
  create(payload: AllowancePayload) {
    return this.createEntity<AllowanceResponse, AllowancePayload>(
      Resource.Allowance,
      payload
    );
  }

  /**
   * Delete a allowance by id
   * @param {Id} id allowance id
   */
  delete(id: Id) {
    return this.deleteEntity(Resource.Allowance, id);
  }

  /**
   * Update a allowance by id
   * @param {Id} id resource id
   * @param {AllowancePayload} payload
   * @param {string} payload.name allowance name
   */
  update(id: Id, payload: AllowancePayload) {
    return this.updateEntity<AllowancePayload>(Resource.Allowance, id, payload);
  }

  /**
   * Update a allowance by id
   * @param {Id} id resource id
   * @param {AllowancePayload} payload
   * @param {string} payload.name allowance name
   */
  notify(id: Id) {
    const url = `${this.buildUrl(Resource.Allowance)}/notify?id=${id}`;
    return this.makeRequest<SuccessResponse>({
      url,
      method: this._request.Post
    });
  }
}
